"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GradacaoNeutros;
(function (GradacaoNeutros) {
    GradacaoNeutros["BrancoMU50"] = "#FDFDFD";
    GradacaoNeutros["CinzaFillMU100"] = "#F3F3F3";
    GradacaoNeutros["CinzaFillMU200"] = "#DADADA";
    GradacaoNeutros["CinzaFillMU300"] = "#CDCDCD";
    GradacaoNeutros["CinzaFillMU400"] = "#C1C1C1";
    GradacaoNeutros["CinzaFillMU500"] = "#A2A1A1";
    GradacaoNeutros["CinzaFillMU600"] = "#646363";
    GradacaoNeutros["PretoFillMU700"] = "#504F4F";
    GradacaoNeutros["PretoFillMU800"] = "#3C3B3B";
    GradacaoNeutros["PretoMU900"] = "#001729";
})(GradacaoNeutros || (GradacaoNeutros = {}));
exports.default = GradacaoNeutros;
